'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var isStamp = function isStamp(obj) {
  return typeof obj === 'function' && typeof obj.compose === 'function';
};

exports['default'] = isStamp;
module.exports = exports['default'];
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/stamp-utils/build/is-stamp/index.js
 ** module id = 498
 ** module chunks = 0
 **/